module.exports = __webpack_public_path__ + "img/DMH.ffbf0569.jpg";